class MyFormData extends FormData {
    constructor(id: any) {
        super(document.getElementById(id) as HTMLFormElement);
    }

    toJson() {
        const setValue = (obj: any, value: any, path: string) => {
            var a = path.split(".");
            var o = obj;
            for (var i = 0; i < a.length - 1; i++) {
                var n = a[i];
                if (o && o.hasOwnProperty(n)) {
                    o = o[n];
                } else {
                    o = o || {};
                    o[n] = {};
                    o = o[n];
                }
            }
            o[a[a.length - 1]] = value;

            return obj;
        }

        let json = {};
        this.forEach(function (value, key) {
            setValue(json, value, key);
        });
        return json;
    }
}

export default MyFormData;